import { styled, alpha } from '@mui/material/styles';
import { InputBase } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface InputBaseSearchProps{
    search: string,
    onSearch: (data: string) => void,
    expandable?: boolean
}
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: alpha(theme.palette.common.black, 0.05),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.5),
    },
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(3),
    width: 'auto',
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        paddingLeft: `calc(1em + ${theme.spacing(5)})`
    },
    '&.expandable .MuiInputBase-input': {
        transition: theme.transitions.create('width'),
        width: '0ch',
        '&:focus, &:not(:placeholder-shown)': {
            width: '15ch',
        },
    },
}));

export default function InputBaseSearch({search, onSearch, expandable}: InputBaseSearchProps) {
    return (
        <Search>
            <SearchIconWrapper className='app-btn-color-third'>
                <FontAwesomeIcon icon="search" />
            </SearchIconWrapper>
            <StyledInputBase
                placeholder="Búsqueda"
                className={`${expandable && 'expandable'}`}
                value={search}
                onChange={data => onSearch(data.target.value)}
                inputProps={{ 'aria-label': 'search' }}
            />
        </Search>
    )
}
